import React, { useEffect, useRef, useState, useContext } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { Container, Box, Typography, Grid2 as Grid, TextField } from '@mui/material';
import { SET_ALERT } from 'context/actions/system';
import { createMail } from 'context/actions/mails';
import { ChevronRight } from 'react-feather';
import { GlobalContext } from 'context';
import { getPageAllList } from 'context/actions/pages';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import { validateEmail } from 'utils/functions';

const Footer = () => {
    const { state, dispatch } = useContext(GlobalContext);
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [menus, setMenus] = useState([]);
    const successTimeout = useRef(null);

    useEffect(() => {
        getMenus();
    }, []);

    const getMenus = async () => {
        const datas = await getPageAllList('?isHeader=0');
        if (datas.status === 'success') setMenus(datas.data);
    };

    const handleSendMail = async () => {
        if (!validateEmail(email)) {
            dispatch({
                type: SET_ALERT,
                data: { isShow: true, type: 'warning', message: t('title.not_validate_mail') },
            });
            return;
        }
        const res = await createMail({ email });
        if (res.status === 'success') {
            dispatch({
                type: SET_ALERT,
                data: { isShow: true, type: 'success', message: t('title.success_register') },
            });
            setEmail('');
        } else {
            dispatch({
                type: SET_ALERT,
                data: {
                    isShow: true,
                    type: 'warning',
                    message:
                        res.message === 'mail_inserted'
                            ? t('title.already_register')
                            : t('title.error_register'),
                },
            });
        }
    };

    return (
        <>
            {/* ── Үндсэн footer ── */}
            <Container
                maxWidth={false}
                disableGutters={true}
                className="bg-primary py-10"
                sx={{ position: 'relative', zIndex: 10 }}
            >
                <Container maxWidth="lg">
                    <Grid container spacing={4}>
                        {/* Бидний тухай + сошиал */}
                        <Grid
                            item="true"
                            size={{ lg: 4, md: 4, sm: 12, xs: 12 }}
                            className="flex flex-col"
                        >
                            <Typography
                                variant="body14"
                                className="uppercase text-white font-medium !mb-2"
                            >
                                {t('title.own_about')}
                            </Typography>
                            {menus.map((m, ind) => (
                                <Box key={ind} className="flex flex-col">
                                    <Link
                                        href={m.url ? '/' + m.url : '/content/' + m.id}
                                        passHref
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <Typography
                                            variant="body12"
                                            className="text-white font-medium !mt-2"
                                        >
                                            {
                                                m.names.find(
                                                    (item) => item.langCode === i18n.language
                                                )?.name
                                            }
                                        </Typography>
                                    </Link>
                                </Box>
                            ))}
                            <Typography variant="body14" className="text-white font-medium !mt-8">
                                {t('title.other')}
                            </Typography>
                            <Box className="flex flex-row !mt-3 items-center">
                                <Image
                                    width={36}
                                    height={36}
                                    src={require('public/facebook.svg')}
                                    alt="Facebook"
                                    className="cursor-pointer mr-8"
                                    onClick={() =>
                                        window.open(
                                            'https://fb.com',
                                            '_blank',
                                            'noopener,noreferrer'
                                        )
                                    }
                                />
                                <Image
                                    width={36}
                                    height={36}
                                    src={require('public/instagram.svg')}
                                    alt="Instagram"
                                    className="cursor-pointer !mr-8"
                                    onClick={() =>
                                        window.open(
                                            'https://instagram.com',
                                            '_blank',
                                            'noopener,noreferrer'
                                        )
                                    }
                                />
                                <Image
                                    width={36}
                                    height={36}
                                    src={require('public/youtube.svg')}
                                    alt="YouTube"
                                    className="cursor-pointer !mr-8"
                                    onClick={() =>
                                        window.open(
                                            'https://youtube.com',
                                            '_blank',
                                            'noopener,noreferrer'
                                        )
                                    }
                                />
                                {state?.auth?.accountLoggedIn &&
                                    state?.auth?.account?.accountInfo?.type === 'business' && (
                                        <Image
                                            width={80}
                                            height={80}
                                            src={require('public/googledrive.svg')}
                                            alt="Google Drive"
                                            className="cursor-pointer !mr-8"
                                            onClick={() =>
                                                window.open(
                                                    'https://drive.google.com/drive/folders/1BrlHUaKv6hL5382k_jmm3TC_cIVDBRAy?usp=drive_link',
                                                    '_blank',
                                                    'noopener,noreferrer'
                                                )
                                            }
                                        />
                                    )}
                            </Box>
                        </Grid>

                        {/* Үйлчилгээний нөхцөл */}
                        <Grid
                            item="true"
                            size={{ lg: 4, md: 4, sm: 12, xs: 12 }}
                            className="flex flex-col"
                        >
                            <Typography
                                variant="body14"
                                className="uppercase text-white font-medium"
                            >
                                {t('title.term_of_service')}
                            </Typography>
                            {[
                                t('title.term_of_service'),
                                t('title.delivery_condition'),
                                t('title.guarentee_of_conf'),
                            ].map((label, ind) => (
                                <Typography
                                    key={ind}
                                    variant="body12"
                                    className="text-white font-medium !mt-2 cursor-pointer"
                                    onClick={() =>
                                        window.open(
                                            'https://ff.com',
                                            '_blank',
                                            'noopener,noreferrer'
                                        )
                                    }
                                >
                                    {label}
                                </Typography>
                            ))}
                        </Grid>

                        {/* Мэдэгдэл авах */}
                        <Grid
                            item="true"
                            size={{ lg: 4, md: 4, sm: 12, xs: 12 }}
                            className="flex flex-col"
                        >
                            <Typography
                                variant="body14"
                                className="uppercase text-white font-medium"
                            >
                                {t('title.get_information')}
                            </Typography>
                            <Typography variant="body12" className="text-white font-medium !mt-4">
                                {t('paragraph.mail_to_get_information')}
                            </Typography>
                            <Box className="flex flex-row !my-3 items-center">
                                <TextField
                                    placeholder={t('input.mail_address')}
                                    variant="outlined"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    onKeyDown={(e) => e.key === 'Enter' && handleSendMail()}
                                    sx={{
                                        flex: 1,
                                        height: 46,
                                        '& .MuiOutlinedInput-root': {
                                            height: '100%',
                                            borderRadius: 0,
                                            background: '#fff',
                                            '& fieldset': { border: 'none' },
                                        },
                                        '& .MuiInputBase-input': {
                                            padding: '10px',
                                            fontSize: 12,
                                        },
                                    }}
                                />
                                <Box
                                    className="bg-primary-950 flex justify-center items-center cursor-pointer"
                                    sx={{
                                        height: 46,
                                        width: 46,
                                        flexShrink: 0,
                                        transition: 'opacity .15s',
                                        '&:hover': { opacity: 0.85 },
                                    }}
                                    onClick={handleSendMail}
                                >
                                    <ChevronRight color="white" size={18} />
                                </Box>
                            </Box>
                            <Typography variant="body12" className="text-white font-medium">
                                {t('paragraph.mail_to_accept_privacy')}
                            </Typography>
                        </Grid>
                    </Grid>
                </Container>
            </Container>

            {/* ── Доод мөр ── */}
            <Container
                maxWidth={false}
                disableGutters={true}
                className="flex justify-center items-center bg-primary-900 h-8"
            >
                <Container maxWidth="lg" className="flex flex-row justify-center">
                    <Typography variant="body12" className="text-white">
                        {t('title.right_reserved')}
                    </Typography>
                </Container>
            </Container>
        </>
    );
};

export default Footer;
